// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner-uJnej","title":"title-VzAZ6","viewAll":"viewAll-1g93c","eventCard":"eventCard-1ffvv"};